import template_t1 from './templates/products-page-toolbox-t1.view.html';
import templateAD from './templates/products-page-toolbox.view-adaptative.html';

function MenuDirective(SessionService) {

    let response = SessionService.get('components');
    let htmlTemplate = template_t1;
    if (__env.adaptative){
      htmlTemplate = templateAD;
    }else{
        htmlTemplate = template_t1;
    }


    return {
        restrict: 'E',
        template: htmlTemplate
    };
}

MenuDirective.$inject = ['SessionService'];

export default MenuDirective;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/products-list/products-page-toolbox/products-page-toolbox.directive.js
 **/